import { S, save, ui } from "../app/store.js";

function log(a, d) {
  S.audit.push({ t: new Date().toISOString(), u: ui.user, a, d });
  save();
}

export { log };
